import { injectable } from 'inversify';
import { type Utils } from './interfaces';

@injectable()
export class BrowserUtils implements Utils {
  encodeBase64(input: string): string {
    const utf8Bytes = new TextEncoder().encode(input);
    const binaryString = Array.from(utf8Bytes)
      .map((byte) => String.fromCharCode(byte))
      .join('');
    return btoa(binaryString);
  }
  decodeBase64(input: string): string {
    const binaryString = atob(input);
    const binaryBytes = new Uint8Array(
      binaryString.split('').map((char) => char.charCodeAt(0)),
    );
    return new TextDecoder().decode(binaryBytes);
  }
}
